import React, { useState } from "react";
import { User } from "lucide-react";
import { toast } from "sonner";
import { cn } from "@/lib/utils";

const AgentPhoneChip = ({ phone, isDark, title }) => {
  const [copied, setCopied] = useState(false);

  if (!phone) {
    return <span className={isDark ? "text-slate-500" : "text-gray-400"}>-</span>;
  }

  const handleClick = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(String(phone));
      setCopied(true);
      toast.success("Numara kopyalandı");
      setTimeout(() => setCopied(false), 1600);
    } catch {
      toast.error("Kopyalanamadı");
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      title={title || "Kopyalamak için tıklayın"}
      className={cn(
        "inline-flex items-center gap-1.5 px-2 py-1 rounded font-mono text-xs cursor-copy transition-colors",
        copied
          ? (isDark ? "bg-emerald-500/20 text-emerald-300 ring-1 ring-emerald-500/30" : "bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200")
          : (isDark ? "bg-slate-800 text-slate-300 hover:bg-slate-700" : "bg-gray-100 text-gray-700 hover:bg-gray-200")
      )}
    >
      <User className="w-3 h-3 shrink-0 opacity-70" />
      {phone}
    </button>
  );
};

export default AgentPhoneChip;
